import { initWasm, Resvg } from './resvg';

const resvgInit = initWasm(fetch('/assets/resvg.wasm'));

export const svgToPng = async (text: string, size?: number): Promise<Blob> => {
  // Fix images without dimensions and data uri
  const [, width, height] =
    text.match(/viewBox="\d+\s+\d+\s(\d+)\s+(\d+)"/) ?? [];
  text = text.replace(/<image(.+?)\/>/g, (_, attributes) => {
    attributes = attributes.replace('href="data:', 'href="http://data:');
    if (!attributes.includes('width="') && width) {
      attributes += ` width="${width}"`;
    }
    if (!attributes.includes('height="') && height) {
      attributes += ` height="${height}"`;
    }
    return `<image ${attributes}/>`;
  });
  const mode =
    width && height && parseInt(width) > parseInt(height) ? 'width' : 'height';

  await resvgInit;
  const resvgJS = new Resvg(
    text,
    size && {
      fitTo: {
        mode,
        value: size,
      },
    },
  );

  const resolved = await Promise.all(
    resvgJS.imagesToResolve().map(async (url: string) => {
      const img = await fetch(url.replace(/^http:\/\/data:/, 'data:'));
      const buffer = await img.arrayBuffer();
      return {
        url,
        buffer: Buffer.from(buffer),
      };
    }),
  );
  if (resolved.length > 0) {
    for (const result of resolved) {
      const { url, buffer } = result;
      resvgJS.resolveImage(url, buffer);
    }
  }
  const bytes = resvgJS.render().asPng();
  return new Blob([bytes], { type: 'image/png' });
};
